import { render, staticRenderFns } from "./FormsListing.vue?vue&type=template&id=7c54e4f2&scoped=true&"
import script from "./FormsListing.vue?vue&type=script&lang=js&"
export * from "./FormsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54e4f2",
  null
  
)

export default component.exports